import React, { useState } from 'react';

import { AiField } from 'components/ai/field';
import { Textarea } from '@buildoutinc/blueprint-react/ui/Textarea';

import PanelFooter from './panel_footer';

interface Props {
  aiEnabled?: boolean;
  collapseKey?: string;
  parentId?: number;
  parentType?: string;
  purpose: string;
  buttonLabel: string;
  date: Date;
  placeholder: string;
  saving: boolean;
  value: string;
  onChange: (value: string) => void;
  onDateChange: (date: Date) => void;
  onSubmit: () => void;
}

export default function ActivityPanel({
  aiEnabled,
  collapseKey,
  parentId,
  parentType,
  purpose,
  buttonLabel,
  date,
  placeholder,
  saving,
  value,
  onChange,
  onDateChange,
  onSubmit,
}: Props) {
  const [generating, setGenerating] = useState(false);

  return (
    <div className="d-flex flex-column gap-3">
      <AiField
        aiEnabled={Boolean(aiEnabled && parentId && parentType)}
        collapseKey={collapseKey}
        context={{ parentId, parentType, purpose }}
        feature="Activity body"
        value={value}
        onChange={onChange}
        onGeneratingChange={setGenerating}
      >
        {({ className, generating }) => (
          <Textarea
            className={className}
            placeholder={placeholder}
            readOnly={generating}
            rows={4}
            value={value}
            onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => onChange(e.target.value)}
          />
        )}
      </AiField>
      <PanelFooter
        buttonLabel={buttonLabel}
        date={date}
        disabled={generating || !value.trim()}
        saving={saving}
        showDate={Boolean(value.trim())}
        onDateChange={onDateChange}
        onSubmit={onSubmit}
      />
    </div>
  );
}
